module.exports = __webpack_public_path__ + "static/img/bg_stage.9308bc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/researchCamp/bg_stage.png
// module id = evMx
// module chunks = 1